<template>
  <div>
    <div class="ls_drawer_main_content">
      <h1 class="item_detail_header mb-15">{{ detail.full_name }}
        <Tag color="success">{{ detail.role_display }}</Tag>
      </h1>

      <Row type="flex" align="middle" class="fs-15 color-grey mb-30">
        <Col :xs="24" :sm="6">
          <img v-if="detail.image_url" :src="imgUrl + detail.image_url" alt="" class="user-img">
          <img v-else src="/static/img/user_avatar_60x60.png" alt="" class="user-img">
        </Col>

        <Col :xs="24" :sm="16" :md="14">

          <!-- CREATED DATE -->
          <Row>
            <Col :xs="12" :sm="9">
              Дата создания:
            </Col>
            <Col :xs="12" :sm="9">
              {{ formatDateTime(detail.created_date) }}
            </Col>
          </Row>

          <!--&lt;!&ndash; ROLE &ndash;&gt;-->
          <!--<Row>-->
          <!--<Col span="12">-->
          <!--Роль:-->
          <!--</Col>-->
          <!--<Col span="12">-->
          <!--{{ detail.role_display }}-->
          <!--</Col>-->
          <!--</Row>-->

          <!--&lt;!&ndash; STORES &ndash;&gt;-->
          <!--<Row v-if="stores">-->
          <!--<Col span="12">-->
          <!--Магазины:-->
          <!--</Col>-->
          <!--<Col span="12">-->
          <!--{{ stores }}-->
          <!--</Col>-->
          <!--</Row>-->

          <!-- PHONE -->
          <Row>
            <Col :xs="12" :sm="9">
              Телефон:
            </Col>
            <Col :xs="12" :sm="9">
              <a :href="'tel:'+detail.phone">{{ detail.phone }}</a>
            </Col>
          </Row>

          <!-- EMAIL -->
          <Row v-if="detail.email">
            <Col span="9">
              Email:
            </Col>
            <Col span="9">
              <a :href="'mailto:' + detail.email">{{ detail.email }}</a>
            </Col>
          </Row>
        </Col>
      </Row>





      <!-- RECENT OPERATIONS -->
      <Divider dashed="true"><h2>Последние операции</h2></Divider>

      <recentProductOrders
        style="min-height: 20%; margin-top: 20px"
        filter_by="user"
        :filter_by_id="id"
      ></recentProductOrders>
    </div>
    <div class="ls_drawer_footer" style="margin-top: 20px">
      <Button style="margin-right: 8px" type="primary" @click="cancelAction()">
        <Icon type="md-close"/>
      </Button>
      <Button style="margin-right: 8px" v-if="display_edit_button" type="info" @click="editAction()">
        <Icon type="md-create"/>
      </Button>
      <Button v-if="detail.id !== current_user_id && display_delete_button" type="error" @click="removeModal = true"
              style="float: left"
      >
        <Icon type="md-trash"/>
      </Button>
    </div>


    <!--Modal for remove Item-->
    <Modal
      :footer-hide="footerHide"
      v-model="removeModal"
      title="">

      <h3 class="mb-40">Вы действительно хотите удалить данного пользователя?</h3>

      <Row type="flex" justify="center">
        <Button type="error" @click="removeModal = false">Отмена</Button>
        <Button type="success" style="margin-left: 12px"
                @click="deleteAction()">
          Удалить
        </Button>
      </Row>
    </Modal>


    <Spin size="large" fix v-if="loading"></Spin>
  </div>
</template>

<script>
    import {server_addr} from "../../http.js";
    import {BaseDetailData} from "../../base/base_detail.js";
    import recentProductOrders from "../../components/core/recentProductOrders";

    let _app = BaseDetailData();

    _app.data = function () {
        return {
            loading: true,
            detail: {},
            imgUrl: server_addr,

            //  Additional nested data
            sections: [],
            showAddSectionModal: false,
            formSectionData: {
                name: ""
            },

            removeModal: false,
            footerHide: true,
            removeId: null
        };
    };

    _app.components = {
        recentProductOrders
    };

    // _app.computed.stores = function(){
    //   return this.detail.stores_display.join(', ')
    // };

    _app.computed.display_edit_button = function () {
        if ('can_update' in this.detail) {
            return (this.detail.can_update && (
                this.permissions.indexOf("user.user_update_all") !== -1 ||
                this.permissions.indexOf("user.user_update_owner") !== -1
            ));
        }
        return (
            this.permissions.indexOf("user.user_update_all") !== -1 ||
            this.permissions.indexOf("user.user_update_owner") !== -1
        );
    };
    _app.computed.display_delete_button = function () {
        if ('can_delete' in this.detail) {
            return (this.detail.can_delete && (
                this.permissions.indexOf("user.user_delete_all") !== -1 ||
                this.permissions.indexOf("user.user_delete_owner") !== -1
            ));
        }
        return (
            this.permissions.indexOf("user.user_delete_all") !== -1 ||
            this.permissions.indexOf("user.user_delete_owner") !== -1
        );
    };

    _app.methods.editAction = function () {
        this.$router.push({
            name: this.item_type + "_edit",
            params: {id: this.id}
        });
    };
    export default _app;
</script>

<style scoped>
  .user-img {
    width: 110px;
    height: 110px;
    border-radius: 50%;
  }

  @media screen and (max-width: 1900px) {
    .user-img {
      width: 90px;
      height: 90px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/apps/user/userDetail.vue